var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section bg-gray-4"},[_c('div',{staticClass:"container"},[(_vm.loading)?_c('div',{staticClass:"w-layout-grid grid-quarters cards-grid"},_vm._l((_vm.posts),function(post){return _c('CalendarPost',{key:post.date,attrs:{"post":post,"hashtags":_vm.hashTags}})}),1):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }